export default __webpack_public_path__ + "static/parcheesi_case_video-dd33cef06d036db50a342443b5e81ab3.mp4";